import { reserva_de_vagas_nao_confirmadas } from "./reserva-de-vagas-nao-confirmadas";

const consulta_reserva_de_vaga = [reserva_de_vagas_nao_confirmadas];

export { consulta_reserva_de_vaga };
